module.exports = __webpack_public_path__ + "img/610.790f0ec9.jpg";